import BackgroundVideo from 'epic-react-common/src/components/BackgroundVideo';
import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';

const VideoOverlay = ({video, mobile, tablet, show, close}) => {
    const videoOverlayClass = cx('video-overlay', {visible: show});
    return (
        <div
            role="presentation" onClick={close}
            id="videoOverlay" className={videoOverlayClass}>
            <div className="container full-height">
                <div className="video-container embed-responsive embed-responsive-16by9">
                    <BackgroundVideo
                        play={show}
                        background={video}
                        playsInline
                        controls
                        mute={false}
                        noOverlay
                        mobile={mobile}
                        tablet={tablet} />
                        <div
                            role="presentation" className="close-video"
                            onClick={close}>
                            <i className="icon-cross" />
                        </div>
                </div>
            </div>
        </div>
    );
}

VideoOverlay.propTypes={
    video: PropTypes.object,
    mobile: PropTypes.bool,
    tablet: PropTypes.bool,
    show: PropTypes.bool,
    close: PropTypes.func
}

export default VideoOverlay;

